import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { districtActions } from '../slices/district-slice';
import { ApiDistrict } from '../http';

const {
  setDistrictRequestStart,
  setDistrictRequestSuccess,
  setDistrictRequestFailure,
  setDistrictRequestDefault,

  setDistrictListRequest,
  setDistrictListSuccess,
  setDistrictListFailure,
  setDistrictListDefault,

  setDistrictOneRequest,
  setDistrictOneSuccess,
  setDistrictOneFailure,
  setDistrictOneDefault,

  setDistrictWarehouseRequest,
  setDistrictWarehouseSuccess,
  setDistrictWarehouseFailure,
  setDistrictWarehouseDefault,
} = districtActions;

//List
export const getDistricts = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictListRequest());
  try {
    const data = await ApiDistrict.fetchAll(params);
    dispatch(setDistrictListSuccess(data));
  } catch ({ message }) {
    dispatch(setDistrictListFailure({ message }));
  }
};
export const clearDistricts = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictListDefault());
};

//One
export const getDistrict = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictOneRequest());
  try {
    const data = await ApiDistrict.fetchOne(id);
    dispatch(setDistrictOneSuccess(data));
  } catch ({ message }) {
    dispatch(setDistrictOneFailure({ message }));
  }
};
export const clearDistrict = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictOneDefault());
};

//Warehouse
export const forceGetDistrictWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictWarehouseRequest());
  try {
    const data = await ApiDistrict.fetchAll({ take: 9999 });
    dispatch(setDistrictWarehouseSuccess(data));
  } catch ({ message }) {
    dispatch(setDistrictWarehouseFailure({ message }));
  }
};
export const getDistrictWarehouse = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { warehouse } = storeStates.district;
  if (isEmpty(warehouse.hits) && !warehouse.isLoading) {
    dispatch(forceGetDistrictWarehouse());
  }
};
export const clearDistrictWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictWarehouseDefault());
};

//Create
export const createDistrict = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictRequestStart());
  return new Promise((resolve, reject) => {
    ApiDistrict.createOne(data)
      .then((res) => {
        dispatch(setDistrictRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setDistrictRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editDistrict =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setDistrictRequestStart());
    return new Promise((resolve, reject) => {
      ApiDistrict.updateOne(id, data)
        .then((res) => {
          dispatch(setDistrictRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setDistrictRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteDistrict = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictRequestStart());
  return new Promise((resolve, reject) => {
    ApiDistrict.deleteOne(id)
      .then((res) => {
        dispatch(setDistrictRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setDistrictRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearDistrictRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setDistrictRequestDefault());
};
